// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import { store } from "./stores/rootStore";
import './i18n';
import { LanguageContextProvider } from "./context/languageContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </LanguageContextProvider>
  </React.StrictMode>
);
